import { useSearchQueryActions } from './useSearchQueryActions';
import { useSearchQueryState } from './useSearchQueryState';

export const useSearchQueryReducer = () => ({
  ...useSearchQueryActions(),
  searchQuery: useSearchQueryState(),
});
